module.exports = __webpack_public_path__ + "static/media/logo.15c352fe.png";